import { h } from "preact";

import { useState, useEffect, } from "preact/hooks";
import {
	Box, Card, CardContent,
	CardMedia,
	Grid, MenuItem, Typography, Paper, TextField, Stack
} from "@mui/material";
import DebouncedMapBoxInput from "../Common/DebouncedMapBoxInput";
import LoadingButton from "@mui/lab/LoadingButton";
import { makeStyles } from "@mui/styles";
import MapBox from "../RealEstate/MapBox";
import NumberField from "../Common/NumberField";

const useStyles = makeStyles((theme) => ({

	root: {
		maxWidth: 645,
	},
	media: {
		height: 200,
		width: 300
	},
	ribbon: {
		boxShadow: "0 0 0 2px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
		margin: 0,
		padding: 0,
		background: "#FF3426",
		color: "white",
		padding: "7px 0",
		//padding: "1em 0",
		position: "absolute",
		top: 0,
		left: 0,
		transform: "translateX(-30%) translateY(0%) rotate(-45deg)",
		transformOrigin: "top right",
		"&:before": {
			content: '""',
			position: "absolute",
			top: 0,
			margin: "0 -1px",
			width: "100%",
			height: "100%",
			background: "#FF3426",
			left: "100%",
		},
		"&:after": {
			content: '""',
			position: "absolute",
			top: 0,
			margin: "0 -1px",
			width: "100%",
			height: "100%",
			background: "#FF3426",
			right: "100%",
		},
	},
}
))
export default function Search(props) {
	//console.log("props", props);
	const [state, setState] = useState({ type: 0, budget: "" });
	const [loadingState, setLoadingState] = useState(false);
	const classes = useStyles();
	const handleChangeLoc = (loc) => {
		console.log("handleChangeLoc loc was ", state.loc, "loc is ", loc, state.uid)
		//console.log(loc.center[0], loc.center[1]);
		setState({ ...state, loc: loc, has_loc: true, recs: [], search: false });

	};
	const handleChange = (e) => {

		setState({ ...state, [e.target.name]: e.target.value });

	};
	const handleSearch = () => {
		setLoadingState(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify(state),
		};

		fetch("/anon/98dd88d15fcc493caea69e3ccacf128b", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						console.log(res);
						setLoadingState(false);
						setState({ ...state, uid: res.pld.uid, recs: res.pld.recs, search: true });
						history.replaceState({}, "", "/search/" + res.pld.uid);
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		//console.log("fetch", props);
		if (props.id !== undefined && props.id !== "") {
			fetch("/anon/98dd88d15fcc493caea69e3ccacf128b/" + props.id)
				.then((response) => {
					return response.json();
				})
				.then((res) => {
					switch (res.res) {
						case "ok":
							const ste = { ...state, ...res.pld, search: true, has_loc: true };
							console.log("state from back", ste);
							//setLoadingState(false)
							setState(ste);
							//setState({ ...state, uid: props.id, rec: res.pld, loc: res.loc, budget: res.budget, type: res.type, search: true, has_loc: true });

							break;

						case "err":
							break;
						default:
							break;
					}
				});
		}
	}, []);
	// useEffect(() => {

	// }, [state.rec]);
	return <Grid container spacing={1} sx={{ margin: "0px", paddingTop: "5px" }}>
		<Grid item xs={12} lg={6} style="padding-left: 0px">
			<Paper style="padding: 10px; min-height: 500px">
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
					<DebouncedMapBoxInput resultsCallback={handleChangeLoc} setUpperState={setState} upperState={state} mode="SE" />
					{/* <TextField */}
					<div style="margin-right: 10px; margin-left: 10px">
						<NumberField
							id="budget"
							name="budget"


							value={state.budget ? state.budget : 0}
							onChange={handleChange}

							//variant="outlined"
							//size="small"
							sx={{ marginRight: "10px", marginLeft: "10px" }}

						/>
					</div>
					<TextField
						id="type"
						name="type"
						select
						label=""
						value={state.type ? state.type : 0}
						onChange={handleChange}
						helperText=""
						variant="outlined"
						size="small"
						style="margin-right: 10px;"

					>
						<MenuItem key={0} value={0}>
							<em>Choisir</em>
						</MenuItem>
						<MenuItem key={0} value={1}>
							Appartement
						</MenuItem>
						<MenuItem key={1} value={2}>
							Maison
						</MenuItem>
						<MenuItem key={2} value={3}>
							Terrain
						</MenuItem>
						<MenuItem key={3} value={4}>
							Parking
						</MenuItem>
						<MenuItem key={5} value={5}>
							Commerce
						</MenuItem>
						<MenuItem key={6} value={6}>
							Bureaux
						</MenuItem>
						<MenuItem key={7} value={7}>
							Château
						</MenuItem>
						<MenuItem key={8} value={8}>
							Immeuble
						</MenuItem>
					</TextField>
					<LoadingButton
						variant="contained"
						disabled={!state.has_loc}
						loading={loadingState} onClick={handleSearch}>
						Chercher
					</LoadingButton>
				</div>
				{state.has_loc && state.loc && <MapBox ilat={state.loc.center[1]} ilon={state.loc.center[0]} pts={state.recs} zm={props.id === "france" ? 4 : 12} />}

			</Paper>
		</Grid>
		<Grid item xs={12} lg={6}>
			<Paper style=" height: 100%" sx={{ backgroundColor: "#f7f7f7" }}>
				{state.recs && state.recs.length > 0 && <div>
					<Typography sx={{ padding: "10px" }}>
						{state.recs.length} bien{state.recs.length > 1 ? "s" : ""}
					</Typography>
				</div>
				}
				<div style="display: flex; flex-wrap: wrap;  justify-content: flex-start">
					{/* <Grid container spacing={1} sx={{ margin: "0px" }}> */}
					{state.recs && state.recs.length == 0 && <Typography sx={{ margin: "10px" }}>Pas de résultats pour cette recherche</Typography>
					}

					{state.recs && state.recs.length > 0 && state.recs.map((r) => {

						var t = r.pics
						//var t = r.pics[0]

						return (<div style="margin: 5px; cursor: pointer;">
							<div style={{ padding: "0px", position: "relative", overflow: "hidden" }}>
								{(r.ias || r.oabs) && <span className={classes.ribbon}>{r.ias ? "Vendu" : (r.oabs ? "Offre acceptée" : "Nouveau")}</span>}

								<Card className={classes.root} sx={{ backgroundColor: "#ededf0", width: "300px" }}>

									<CardMedia
										onClick={() => { window.location.href = "/publicpage/" + r.id }}
										className={classes.media}
										image={`${THUMBS_URL}/${r.id}/${t.img}-main.jpg`}
										//image={r.url}
										title="**"
									/>

									<CardContent>
										<Stack >
											{/* <Box> */}
											<Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
												<Typography variant="h5">{r.p}</Typography>
												<Typography variant="body1">{r.ias ? "Vendu" : (r.oabs ? "Offre acceptée" : "En vente")}</Typography>
											</Box>
											{/* </Box> */}
											{/* <Box> */}
											<Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
												<Box>
													<Typography variant="h5">{r.adr1}</Typography>
													<Typography variant="body1">{r.adr2}</Typography>
												</Box>
												<Box>
													<Typography variant="h5">{r.mnt} €</Typography>
													<Typography variant="body1">{r.surf} m2</Typography>
												</Box>
											</Box>
											{/* </Box> */}
										</Stack>
									</CardContent>

								</Card>
							</div>
						</div>)
					})}
					{/* </Grid> */}
				</div>
			</Paper>

		</Grid >
	</Grid >
}
